"use client";
import dynamic from "next/dynamic";
import type { RoutePlannerProps } from "./RoutePlaner";

const RoutePlaner = dynamic(() => import("./RoutePlaner"), { ssr: false });

export const RoutePlanerDynamicWrapper = ({ ...props }: RoutePlannerProps) => {
  return <RoutePlaner {...props} />;
};
